import { useTranslation } from "react-i18next";
import { FormAutocomplete } from "../fields";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

interface DealerFormProperties {
    name: string
    control?: any,
    tenants?: string | string[] | null,
    multiple?: boolean,
    onChange?: any
    disabled?: boolean
}

const DealerForm = ({
    name,
    control,
    tenants,
    multiple = true,
    onChange,
    disabled = false,
}: DealerFormProperties) => {

    const { t } = useTranslation(['booking', 'translation']);
    const { globalData } = useContext(GlobalContext);

    const [options, setOptions] = useState<string[]>([]);

    useEffect(() => {
        var dealers: string[] = [];

        if (Array.isArray(tenants)) {
            globalData?.user?.dealers?.forEach((d: any) =>{
                if (tenants.some(t => d.legalEntities.map((le:any) => le.name).includes(t))) {
                    dealers.push(d.name);
                }
            });
        } else if (tenants) {
            globalData?.user?.dealers?.forEach((d: any) =>{
                if (d.legalEntities.map((le:any) => le.name).includes(tenants)) {
                    dealers.push(d.name);
                }
            });
        }

        setOptions(dealers);

    }, [tenants]);

    return (
        <FormAutocomplete
            name={name}
            label={t("label.dealer")} 
            options={options}
            multiple={multiple}
            isOptionEqualToValue={(opt, value) => opt === value}
            renderOption={(props, option) => 
                <li {...props} key={option}>
                    {t('translation:dealers.'.concat(option))}
                </li>
            }
            onChange={onChange}
            disabled={disabled}
        />
    )

}

export default DealerForm;